const WISHLIST_WEBHOOK_URL =
  "https://apps.bonify.io/api/triggers/workflows/27571/489477/43e7b700bc733654fb343a09e00327ae";

const container = document.querySelector('[data-wishlist_container]');
const language = window.location.pathname.split('/')[1] == 'ru' ? 'RU' : 'UK';
const labels = {
  empty_list: language == 'UK' ? 'Список порожній' : 'Список пуст',
  add_to_cart: language == 'UK' ? 'В кошик' : 'В корзину',
  added: language == 'UK' ? 'Додано до бажаного' : 'Добавлено в желаемое',
};

if(container) {
  const customerId = container.dataset.customer_id !== undefined ? container.dataset.customer_id : '';

  if(customerId) {
    const wishlist = getWishlist();

    fetch('https://wishlpp.pimentos.net/load.php', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        'customerId': customerId,
        'wishlist': wishlist
      })
    })
    .then(response => response.json())
    .then(data => {
      saveWishlist(Object.values(data.wishlist));
      loadWishlist(container, customerId);
    });
  } else
    loadWishlist(container, customerId);
}

function getWishlistCustomer() {
  if (
    window.__WISHLIST_CUSTOMER__ &&
    window.__WISHLIST_CUSTOMER__.email
  ) {
    return window.__WISHLIST_CUSTOMER__;
  }

  return { id: null, email: null };
}

function loadWishlist(container, customerId) {
  const wishlist = getWishlist();

  if (wishlist.length === 0) {
    document.querySelector('.section-wishlist').insertAdjacentHTML('afterend', '<div class="rte"><p style="text-align: justify;">' + labels.empty_list + '</p><br /><br /></div>');
    document.querySelector('.section-wishlist').remove();
  } else {
    let ids = [];
    wishlist.map(key => {
      const [productId, variantId] = key.split(':');
      ids.push('gid://shopify/Product/' + productId);
    });
    const query = `
      query getProductsByIds($ids: [ID!]!, $language: LanguageCode) @inContext(language: $language) {
        nodes(ids: $ids) {
          ... on Product {
            id
            title
            handle
            description
            featuredImage {
              url
            }
            variants(first: 5) {
              edges {
                node {
                  id
                  title
                  price {
                    amount
                    currencyCode
                  }
                  compareAtPrice {
                    amount
                    currencyCode
                  }
                }
              }
            }
          }
        }
      }
    `;

    fetch('https://pprelest.myshopify.com/api/2025-10/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': '253db74e72022c9c112e9b193d941472'
      },
      body: JSON.stringify({
        query,
        variables: { 
          ids: ids,
          language: language
        }
      })
    })
      .then(res => res.json())
      .then(function(response) {
        if(response.data.nodes.length) {
          container.innerHTML = response.data.nodes.map(product => {
            let html = '';

            if(product != null) {
              const productId = product.id.split("/").pop();

              product.variants.edges.forEach(item => {
                const variant = item.node;
                const variantId = variant.id.split("/").pop();
                const key = `${productId}:${variantId}`;

                if(isInWishlist(key)) {
                  html += `
                    <li class="grid__item">
                      <div class="card-wrapper">
                        <use-animate data-animate="zoom-fade-small" class="card card--product" tabindex="-1" animate="">
                          <button type="button" class="wishlist-btn added" data-wishlist="" data-product_id="${productId}" data-variant_id="${variantId}" data-customer_id="${customerId}">
                            <svg fill="currentColor" viewBox="0 0 512 512"><path d="M340.8,98.4c50.7,0,91.9,41.3,91.9,92.3c0,26.2-10.9,49.8-28.3,66.6L256,407.1L105,254.6c-15.8-16.6-25.6-39.1-25.6-63.9  c0-51,41.1-92.3,91.9-92.3c38.2,0,70.9,23.4,84.8,56.8C269.8,121.9,302.6,98.4,340.8,98.4 M340.8,83C307,83,276,98.8,256,124.8  c-20-26-51-41.8-84.8-41.8C112.1,83,64,131.3,64,190.7c0,27.9,10.6,54.4,29.9,74.6L245.1,418l10.9,11l10.9-11l148.3-149.8  c21-20.3,32.8-47.9,32.8-77.5C448,131.3,399.9,83,340.8,83L340.8,83z"></path></svg>
                            <svg fill="currentColor" viewBox="0 0 512 512"><path d="M340.8,83C307,83,276,98.8,256,124.8c-20-26-51-41.8-84.8-41.8C112.1,83,64,131.3,64,190.7c0,27.9,10.6,54.4,29.9,74.6  L245.1,418l10.9,11l10.9-11l148.3-149.8c21-20.3,32.8-47.9,32.8-77.5C448,131.3,399.9,83,340.8,83L340.8,83z"></path></svg>
                          </button>
                          <a href="/products/${product.handle}" class="card__media media-wrapper" tabindex="-1">
                            <div class="card--image-animate image-animate media media--adapt media--hover-effect" style="--image-ratio-percent: 100.0%;">
                              <picture is="prog-picture" class="motion-reduce" data-hq="${product.featuredImage.url}?v=1702642620&amp;width=2000">
                                <source media="(min-resolution: 2dppx) and (max-width: 749px)" srcset="${product.featuredImage.url}?v=1702642620&amp;width=165 165w, ${product.featuredImage.url}?v=1702642620&amp;width=360 360w, ${product.featuredImage.url}?v=1702642620&amp;width=535 535w, ${product.featuredImage.url}?v=1702642620&amp;width=750 750w, ${product.featuredImage.url}?v=1702642620&amp;width=940 940w, ${product.featuredImage.url}?v=1702642620&amp;width=1100 1100w" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 10rem) / 4), (min-width: 750px) calc((100vw - 10rem) / 3), calc(62vw - 3rem)">
                                <img src="${product.featuredImage.url}?v=1702642620&amp;width=1100" alt="${product.title}" srcset="${product.featuredImage.url}?v=1702642620&amp;width=165 165w, ${product.featuredImage.url}?v=1702642620&amp;width=360 360w, ${product.featuredImage.url}?v=1702642620&amp;width=535 535w, ${product.featuredImage.url}?v=1702642620&amp;width=750 750w, ${product.featuredImage.url}?v=1702642620&amp;width=940 940w, ${product.featuredImage.url}?v=1702642620&amp;width=1100 1100w" width="1100" height="1100" loading="eager" class="motion-reduce" sizes="(min-width: 1600px) 367px, (min-width: 990px) calc((100vw - 10rem) / 4), (min-width: 750px) calc((100vw - 10rem) / 3), calc(62vw - 3rem)" is="lazy-image">
                              </picture>
                            </div>
                          </a>
                        </use-animate>
                        <div class="card-information">
                          <a href="/products/${product.handle}" class="full-unstyled-link">
                            <span class="visually-hidden">${product.title}</span>
                          </a>
                          <div class="card-information__wrapper">
                            <a href="/products/${product.handle}" class="card-information__text h4" tabindex="-1">
                              ${product.title}
                            </a>
                            <div class="price">
                              <dl>
                                <div class="price__regular">
                                  <dt>
                                    <span class="visually-hidden visually-hidden--inline">Ціна</span>
                                  </dt>
                                  <dd>
                                    <span class="price-item price-item--regular">
                                      <price-money><bdi>${formatMoney(variant.price.amount, variant.price.currency)}</bdi></price-money>
                                    </span>
                                  </dd>
                                </div>
                                <div class="price__sale">
                                  <dd class="price__compare">
                                    <s class="price-item price-item--regular">
                                      <price-money><bdi></bdi></price-money>
                                    </s>
                                  </dd>
                                  <dd>
                                    <span class="price-item price-item--sale">
                                      <price-money><bdi></bdi></price-money>
                                    </span>
                                  </dd>
                                </div>
                              </dl>
                            </div>
                          </div>
                          <div class="card-information__button">
                            <add-to-cart class="button button--small" data-variant-id="${variantId}">${labels.add_to_cart}<svg class="icon icon-cart" aria-hidden="true" focusable="false">
                                <use href="#icon-cart"></use>
                              </svg>
                            </add-to-cart>
                          </div>
                        </div>
                      </div>
                    </li>
                  `;
                }
              });

              return html;
            }
          }).join('');

          initWishlistButtons();
        }
      });
  }
}

function initWishlistButtons() {
  document.querySelectorAll('[data-wishlist]').forEach(btn => {
    const productId = btn.dataset.product_id;
    const variantId = btn.dataset.variant_id;
    const key = `${productId}:${variantId}`;

    if (isInWishlist(key))
      btn.classList.add('added');

    if(!btn.classList.contains('initialized')) {
      btn.addEventListener('click', (e) => {
        document.dispatchEvent(new CustomEvent('wishlist:click', {
          detail: {
            button: btn,
            productId: btn.dataset.product_id,
            variantId: btn.dataset.variant_id,
            customerId: btn.dataset.customer_id,
            wishlist: getWishlist()
          }
        }));
      });

      btn.classList.add('initialized');
    }
  });
}

function formatMoney(price, currency = 'UAH', locale = 'uk-UA') {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2
  }).format(price);
}

document.addEventListener('wishlist:click', (e) => {
  clickWishlist(e.detail.productId, e.detail.variantId, e.detail.button, true);

  if(e.detail.customerId !== undefined) {
    fetch('https://wishlpp.pimentos.net/click.php', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(e.detail)
    })
    .then(response => response.json())
    .then(data => {
      saveWishlist(Object.values(data.wishlist));
    });
  }
});

function getWishlist() {
  const cookies = document.cookie.split('; ').find(row => row.startsWith('wishlist='));

  if (!cookies) return [];
  
  try {
    return JSON.parse(decodeURIComponent(cookies.split('=')[1]));
  } catch {
    return [];
  }
}

function isInWishlist(key) {
  return getWishlist().includes(key);
}

function saveWishlist(wishlist) {
  const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);

  document.cookie = `wishlist=${encodeURIComponent(JSON.stringify(wishlist))}; expires=${expires.toUTCString()}; path=/`;
}

function clickWishlist(productId, variantId, button, notify = false) {
  const wishlist = getWishlist();
  const key = `${productId}:${variantId}`;

  if (!isInWishlist(key)) {
    wishlist.push(key);

    saveWishlist(wishlist);

    if(button)
      button.classList.add('added');

    const customer = getWishlistCustomer();

    sendWishlistWebhook({
      customer: customer,
      product: {
        id: productId,
        variant_id: variantId,
        title: button.dataset.product_title || null,
        url: button.dataset.product_url || null,
        image: button.dataset.product_image || null
      }
    });

    if(notify) {
      button.insertAdjacentHTML('afterend', '<div class="wishlist-notification">' + labels.added + '</div>');
      const notification = button.nextElementSibling;

      setTimeout(() => {
        notification.classList.add('visible');

        setTimeout(() => {
          notification.classList.remove('visible');

          setTimeout(() => {
            notification.remove();
          }, 300);
        }, 3000);
      }, 100);
    }
  } else {
    const newWishlist = wishlist.filter(id => id !== key);

    saveWishlist(newWishlist);

    if(button)
      button.classList.remove('added');

    const notification = button.nextElementSibling;

    if(notification.classList.contains('wishlist-notification'))
      notification.remove();
  }
}

function sendWishlistWebhook({ customer, product }) {
  const payload = {
    customer_id: String(customer.id) || null,
    customer_email: customer.email || "guest@example.com",

    product_id: product.id,
    variant_id: product.variant_id,

    product_title: product.title,
    product_url: product.url,
    product_image: product.image,

    added_at: new Date().toISOString(),
    is_guest: !customer.id
  };

  console.log("Wishlist webhook payload:", payload);

  fetch(WISHLIST_WEBHOOK_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload)
  })
    .then(async res => {
      const text = await res.text();
      console.log("Wishlist webhook response:", {
        status: res.status,
        ok: res.ok,
        body: text
      });
    })
    .catch(err => {
      console.error("Wishlist webhook error:", err);
    });
}


initWishlistButtons();
/*
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-wishlist]');

  if (!btn) return;

  const productId = btn.dataset.product_id;
  const variantId = btn.dataset.variant_id;
  const customerId = btn.dataset.customer_id || '';

  document.dispatchEvent(new CustomEvent('wishlist:click', {
    detail: {
      button: btn,
      productId,
      variantId,
      customerId,
      wishlist: getWishlist()
    }
  }));
});
*/